'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx dom */


var propTypes = {
	class: {
		type: 'string'
	},
	onClick: {
		type: 'function'
	},
	small: {
		type: 'boolean'
	},
	style: {
		type: 'string'
	}
};

function render(_ref) {
	var props = _ref.props;
	var onClick = props.onClick,
	    small = props.small,
	    style = props.style;

	var classes = _defineProperty({
		Icon: true,
		'Icon--small': small
	}, 'Icon--' + style, Boolean(style));

	return (0, _magicVirtualElement2.default)('i', { 'class': [classes, props.class], onClick: onClick });
}

exports.default = { propTypes: propTypes, render: render };